export const COLLAPSED_SIDE_BAR_WIDTH = 80
